import React from 'react';

const FeaturesBlock = ({ data }) => {
  return (
    <section className="features">
      <div className="container">
        <h2>{data.title}</h2>
        <div className="features-grid">
          {data.items.map((item, index) => (
            <div key={index} className="feature-card fade-in-up">
              {/* <div className="feature-icon">{item.icon}</div> */}
              <h3 className="feature-title">{item.title}</h3>
              <p className="feature-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesBlock; 